(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["redirect-banner"]) return;
  try {
    
  console.log(isKoreanUser(), 'language check');

    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
      const nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    function isKoreanUser (){
      let userLangs = []
      let isStartedWithKo = false;
      
      if(navigator.languages && navigator.languages.length !== 0){
        userLangs = navigator.languages;
        
        isStartedWithKo = userLangs.some(lang => {
          return lang.startsWith('ko')
        })
      } 
      else{
        //  If not supported by the browser, use navigator.userLanguage or navigator.language
        const userLang = window.navigator.userLanguage || window.navigator.language;
        isStartedWithKo = userLang.startsWith('ko')
      }

      return isStartedWithKo
    }


  

    if(isKoreanUser()){
      const isUserOnPageFromCookie = JSON.parse(getCookie('isUserOnPage'));        
     
      if(isUserOnPageFromCookie){
            return;
        }

      $('#redirect-modal').css({
        display: 'flex'
      });
  
   
     const modal = document.getElementById("redirect-modal");
      window.addEventListener("click", (event) => {
          if (event.target === modal) {
            modal.style.display = "none"; 
            setCookie('isUserOnPage', 'true', 7); 
          }
        });
      
      $('#close-modal').click(function(){        
        $("#redirect-modal").css('display','none');
        setCookie('isUserOnPage', 'true', 7); 
     
      });

        $('#stay-btn').click(function(){   
        $("#redirect-modal").css('display','none');
        setCookie('isUserOnPage', 'true', 7); 
      });

    }

  } catch(e) { console.error(e); }
})();

})();
